import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { UserMenuComponent } from "./user-menu.component";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,

        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatDividerModule
    ],
    exports: [UserMenuComponent],
    declarations: [UserMenuComponent]
})
export class UserMenuModule {}
